import React from 'react';
import { useNavigate } from 'react-router-dom';
import useScrollAnimation from '../../hooks/useScrollAnimation';
import './ProgramDetail.css';

const StudentsScheme = () => {
    useScrollAnimation();
    const navigate = useNavigate();

    const handleBackClick = () => {
        navigate('/programs/food');
    };

    return (
        <div className="program-detail-page">
            <div className="program-hero">
                <div className="container">
                    <button onClick={handleBackClick} className="back-link">
                        <i className="fas fa-arrow-left"></i> Back to Food Program
                    </button>
                    <div className="program-hero-content">
                        <div className="program-icon-hero">
                            <i className="fas fa-graduation-cap"></i> 
                        </div>
                        <h1>Engal Maanavar Annadhana Scheme</h1>
                        <p className="program-tagline">Nourishing young minds for a brighter future</p>
                    </div>
                </div>
            </div>

            <div className="program-content">
                <div className="container">
                    <section className="program-section scroll-animate">
                        <h2>About the Scheme</h2>
                        <p>Engal Maanavar (Our Students) Annadhana Scheme is dedicated to providing nutritious dinner to needy students. We believe that no child should study on an empty stomach, and proper nutrition is essential for academic success and growth.</p>
                        <p>This program ensures that underprivileged students receive a healthy meal every evening, allowing them to focus on their studies without worrying about hunger. We serve meals with care, dignity, and the hope of empowering these children for a better future.</p>
                    </section>

                    <section className="program-section scroll-animate">
                        <h2>Key Achievements</h2>
                        <div className="achievements-grid">
                            <div className="achievement-card">
                                <div className="achievement-number">70+</div>
                                <div className="achievement-label">Students Served</div>
                                <p>Daily beneficiaries of dinner program</p>
                            </div>
                            <div className="achievement-card">
                                <div className="achievement-number">100%</div>
                                <div className="achievement-label">Free Service</div>
                                <p>No cost to students or families</p>
                            </div>
                            <div className="achievement-card">
                                <div className="achievement-number">365</div>
                                <div className="achievement-label">Days a Year</div>
                                <p>Continuous support for students</p>
                            </div>
                        </div>
                    </section>

                    <section className="program-section scroll-animate">
                        <h2>What We Offer</h2>
                        <div className="features-list">
                            <div className="feature-item">
                                <i className="fas fa-check-circle"></i>
                                <div>
                                    <h3>Nutritious Dinner</h3>
                                    <p>Balanced meal with proteins, carbs, and vitamins</p>
                                </div>
                            </div>
                            <div className="feature-item">
                                <i className="fas fa-check-circle"></i>
                                <div>
                                    <h3>Daily Service</h3>
                                    <p>Dinner provided every single day of the year</p>
                                </div>
                            </div>
                            <div className="feature-item">
                                <i className="fas fa-check-circle"></i>
                                <div>
                                    <h3>Student-Friendly Menu</h3>
                                    <p>Tasty and nutritious meals children enjoy</p>
                                </div>
                            </div>
                            <div className="feature-item">
                                <i className="fas fa-check-circle"></i>
                                <div>
                                    <h3>Hygienic Preparation</h3>
                                    <p>Clean, safe food handling and cooking</p>
                                </div>
                            </div>
                            <div className="feature-item">
                                <i className="fas fa-check-circle"></i>
                                <div>
                                    <h3>Nutritional Supplements</h3>
                                    <p>Fruits, milk, and health drinks included</p>
                                </div>
                            </div>
                            <div className="feature-item">
                                <i className="fas fa-check-circle"></i>
                                <div>
                                    <h3>Dignified Service</h3>
                                    <p>Meals served with respect and care</p>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="program-section scroll-animate">
                        <h2>Daily Schedule</h2>
                        <div className="activities-timeline">
                            <div className="activity">
                                <div className="activity-day">5:00 PM</div>
                                <div className="activity-content">
                                    <h3>Meal Preparation</h3>
                                    <p>Fresh ingredients and cooking begins for students</p>
                                </div>
                            </div>
                            <div className="activity">
                                <div className="activity-day">7:00 PM</div>
                                <div className="activity-content">
                                    <h3>Dinner Service</h3>
                                    <p>Hot, nutritious dinner served to 70+ students</p>
                                </div>
                            </div>
                            <div className="activity">
                                <div className="activity-day">8:00 PM</div>
                                <div className="activity-content">
                                    <h3>Clean Up</h3>
                                    <p>Kitchen cleaned and prepared for next day</p>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="program-section scroll-animate">
                        <h2>Menu Highlights</h2>
                        <div className="menu-grid">
                            <div className="menu-item">
                                <h3>Balanced Meals</h3>
                                <p>Rice, Dal, Vegetables, Curd</p>
                            </div>
                            <div className="menu-item">
                                <h3>Variety Dishes</h3>
                                <p>Biryani, Fried rice, Noodles weekly</p>
                            </div>
                            <div className="menu-item">
                                <h3>Healthy Additions</h3>
                                <p>Eggs, chicken curry on special days</p>
                            </div>
                            <div className="menu-item">
                                <h3>Treats & Snacks</h3>
                                <p>Fruits, sweets, and festival specials</p>
                            </div>
                        </div>
                    </section>

                    <section className="program-section scroll-animate">
                        <h2>Program Impact</h2>
                        <div className="impact-stats">
                            <div className="impact-item">
                                <i className="fas fa-book-reader"></i>
                                <h3>Better Academic Performance</h3>
                                <p>Well-fed students can focus on learning</p>
                            </div>
                            <div className="impact-item">
                                <i className="fas fa-heartbeat"></i>
                                <h3>Improved Health</h3>
                                <p>Proper nutrition supports growth and immunity</p>
                            </div>
                            <div className="impact-item">
                                <i className="fas fa-child"></i>
                                <h3>Reduced Dropout</h3>
                                <p>Food security helps keep children in school</p>
                            </div>
                        </div>
                    </section>

                    <section className="program-section scroll-animate">
                        <h2>Who We Serve</h2>
                        <div className="beneficiaries-info">
                            <p>Our program targets underprivileged students who come from economically disadvantaged families. These children often struggle with food insecurity, which affects their ability to study and succeed in school.</p>
                            <p>By providing a reliable daily dinner, we ensure these students can concentrate on their education without the distraction of hunger, giving them hope and opportunity for a better future.</p>
                        </div>
                    </section>

                    <section className="program-cta scroll-animate">
                        <h2>Support Engal Maanavar Scheme</h2>
                        <p>Your donation helps feed more students and shape brighter futures</p>
                        <div className="cta-buttons">
                            <button onClick={() => navigate('/donate')} className="btn btn-primary btn-large">Donate Now</button>
                            <button onClick={() => navigate('/contact')} className="btn btn-secondary btn-large">Volunteer with Us</button>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default StudentsScheme;
